function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 60h120v96H4z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 60.82V40A36 36 0 0164 4a36 36 0 0136 36v20.82"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 80,
  r: 4
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 80,
  r: 2.5
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 80,
  r: 1
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 80,
  r: 4
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 80,
  r: 2.5
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 80,
  r: 1
});

var SvgShopping = function SvgShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 128 160",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default SvgShopping;